import React, { useState, useEffect, useRef } from "react";
import searchImg from "../../assets/images/search.svg";
import edit_note from "../../assets/images/edit.svg";
import "../theme2.css";
import Nav from "../../theme_1/Nav";
import { axiosInstance } from "../../../config/axiosConfig";
import Button from "../../ui/Button";
import DataTable from "../../ui/DataTable";
import NewAdministrators from "./NewAdministrators";
import Modal from "../../common/modal";

function ManageAdmin(props) {
  const [filter, setFilter] = useState({
    page: 0,
    searchValue: "",
    limit: 10,
  });
  const [searchText, setSearchText] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [addEditModal, setAddEditModal] = useState(false);
  const [addEditModalId, setAddEditModalId] = useState();
  const [loader, setLoader] = useState(false);

  const getStaffByQuery = async ({ load } = {}) => {
    !load && setLoader(true);
    try {
      let url = `v1/LHS/admin/adminList?skip=${filter?.page * 10}&search=${
        filter?.searchValue
      }&limit=${filter?.limit}&sort=desc`;
      var res = await axiosInstance.get(url);
      if (res?.data?.status === 200) {
        setStaffs(res.data?.data?.data);
        setTotalPage(res.data?.data?.count);
      }
    } catch (err) {
      setStaffs([]);
      setTotalPage(0);
    } finally {
      setLoader(false);
      setButtonLoader(false);
    }
  };

  const changeAdminStatus = async (status, id) => {
    setButtonLoader(id);
    try {
      const userObj = {
        isDeleted: status ? false : true,
      };
      let url = `v1/LHS/admin/update/${id}`;
      var res = await axiosInstance.put(url, userObj);
    } catch (err) {
    } finally {
      getStaffByQuery({ load: true });
    }
  };

  useEffect(() => {
    getStaffByQuery();
  }, [filter]);

  const debounceTimer = useRef(null);

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
      debounceTimer.current = null;
    }
    debounceTimer.current = setTimeout(() => {
      setFilter((prev) => ({
        ...prev,
        page: 0,
        searchValue: value,
        limit: value.length > 0 ? 99999999 : 10,
      }));
    }, 300);
  };

  const columns = [
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Email Address",
      key: "email",
    },
    {
      title: "Permissions",
      key: "permissions",
      render: (item) => {
        return (
          <>
            {item.permissions.map((data, index) => (
              <span key={index}>
                {data}
                {index != item?.permissions?.length - 1 && ","}
              </span>
            ))}
          </>
        );
      },
    },
    {
      title: "Change Status",
      key: "changeStatus",
      render: (item) => {
        return (
          <>
            <Button
              loading={item?._id == buttonLoader}
              className="rounded-full"
              style={{
                background: !item.isDeleted ? "#ff7675" : "#73C7A9",
              }}
              onClick={() => changeAdminStatus(item.isDeleted, item._id)}
            >
              {item.isDeleted ? "Enable" : "Disable"}
            </Button>
          </>
        );
      },
    },
    {
      title: "Action",
      key: "actions",
      render: (item) => {
        return (
          <div className="flex justify-between h-5 w-15 relative">
            {/* <div className="relative w-5">
            <img
              onClick={() => openReview(item)}
              className="cursor-pointer"
              src={delete_note}
              alt="Logo"
            />
          </div> */}
            <div className="relative w-5">
              <img
                onClick={() => {
                  setAddEditModal(true);
                  setAddEditModalId(item);
                }}
                className="cursor-pointer"
                src={edit_note}
                alt="Logo"
              />
            </div>
          </div>
        );
      },
    },
  ];

  const onPageChange = (e) => {
    setFilter((prev) => ({ ...prev, page: e - 1 }));
  };

  return (
    <>
      <Nav />
      <div
        className="flex justify-center"
        style={{ backgroundColor: "#F3F2EF", minHeight: "calc(100vh - 60px)" }}
      >
        <div
          className="lg:flex gap-3 block align-top py-4 w-11/12 md:w-3/4 mx-auto flex-col max-w-[1500px]"
          style={{ minHeight: "calc(100vh - 72px)" }}
        >
          <div className="bg-white overflow-hidden rounded-tr-xl rounded-tl-xl">
            <div className="flex items-center justify-between p-4">
              <div className="w-full flex justify-between ">
                <div className="flex w-1/2 gap-3 top_NSearch overflow-hidden">
                  <img className="w-5" alt="search.svg" src={searchImg} />
                  <input
                    className="w-full"
                    placeholder="Search admin name"
                    type="text"
                    value={searchText}
                    onChange={handleSearch}
                  />
                </div>
                <button
                  className="w-60 admin_mngAdmin_roleFilter admin_mngAdmin_addAdmin"
                  onClick={() => {
                    setAddEditModalId();
                    setAddEditModal(true);
                  }}
                >
                  + Add New Administrators
                </button>
              </div>
            </div>
            <DataTable
              columns={columns}
              data={staffs}
              totalRecords={totalPage}
              onPageChange={onPageChange}
              onSearch={null}
              loader={loader}
              holdPageState={filter?.page}
              // moveBack={moveBack}
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={addEditModal}
        onClose={() => setAddEditModal(false)}
        className={"md:w-1/2 md:mt-0"}
      >
        <NewAdministrators
          administratorData={addEditModalId}
          closeModal={() => {
            getStaffByQuery();
            setAddEditModal(false);
          }}
        />
      </Modal>
    </>
  );
}

export default ManageAdmin;
